// Generator route (logged-in app). Keep keys in sync with en/appGenerator.ts.
// EXACT current Polish, verbatim. User-facing render currency = "gemy".
// Dynamic data (track filenames, pack/collection names, counts) stays in the
// component — only static visible copy is translated here.
//
// Sesja 08 (2026-09-07): słownik LOCKED na tym ekranie — „Utwór”, „Paczki klipów”,
// „Tekst”, „Hook na start”, „Podgląd”, „paczka/paczki”. Adresy techniczne z dawnym
// słowem (`batchQueued.*`) zostają: to adresy, nie copy.
export const appGenerator = {
  empty: {
    title: 'Najpierw wgraj utwór',
    body: 'Generator potrzebuje muzyki. Wgraj swój utwór, a EDIMI wykryje beat i najgłośniejsze 30 sekund, i utnie klipy w rytm.',
    upload: 'Wgraj utwór',
  },
  steps: {
    choose: 'Wybierz',
    // Wiersz, w którym coś już wybrano, nie prosi o wybór drugi raz (sesja 21 decyzja 9).
    change: 'Zmień',
    add: 'Dodaj',
    notSelected: 'Nie wybrano',
    loading: 'Wczytuję…',
    music: {
      tag: 'Utwór',
      editLyrics: 'Edytuj tekst',
      recent: '{n} ostatnie z {total}',
      search: 'Szukaj w Muzyce…',
      all: 'Wszystkie utwory ({total})',
      fewer: 'Mniej utworów',
      // Kafel bez fali: szczyty jeszcze się nie policzyły (202) albo utwór nie ma audio
      // (409). Zero słupków-atrapy — stan słowem (G4-generator-M2).
      noWave: 'fala jeszcze się nie policzyła',
      noResults: 'Żaden utwór nie pasuje do „{query}”.',
    },
    shots: {
      tag: 'Paczki klipów',
      all: 'Wszystkie paczki ({total})',
      desc: 'Gotowe paczki EDIMI albo własne klipy z Klipów. EDIMI potnie je w rytm beatu.',
      empty: 'Brak paczek klipów',
      emptyCta: 'Dodaj paczkę w Klipach',
      loadError: 'Nie udało się wczytać Twoich paczek klipów.',
      // Forma za `total`: „1 z 1 paczki”, „2 z 4 paczek” (dopełniacz od 2 w górę).
      selected_one: '{n} z {total} paczki wybranych',
      selected_few: '{n} z {total} paczek wybranych',
      selected_many: '{n} z {total} paczek wybranych',
      clear: 'Wyczyść',
      state: {
        ready: 'gotowa',
        uploading: 'wgrywa się',
        uploadingProgress: '{done} z {total}',
        unusable: 'bez użytecznych klipów',
      },
      // Kafel „wgraj klipy” nie wgrywa w Generatorze — prowadzi do Klipów (decyzja 08 nr 3).
      // Dwa słowa, bo kafel paczki ma 110 px, a „Wgraj własne klipy” ucinało „klipy” (PROD1 FR-8).
      upload: 'Wgraj klipy',
      uploadHint: 'otwiera Klipy',
      own: 'własna',
      clips: '{count} klipów',
      clips_one: '{count} klip',
      clips_few: '{count} klipy',
      clips_many: '{count} klipów',
      // Karta paczki w trakcie ciecia (albo bez zadnego klipu): miniatury dopiero sie
      // licza. Zdanie mowi to wprost, zamiast pustej ramki (sesja 21 decyzja 5). Paczka
      // GOTOWA bez kadrow niesie liczbe klipow, nie to zdanie.
      freshCut: 'świeżo pocięta - kadry w drodze',
    },
    lyrics: {
      tag: 'Tekst',
      styleLabel: 'Styl:',
    },
    hooks: {
      tag: 'Hook na start',
      optional: 'opcjonalnie',
      desc: 'Krótki napis na start editu. Wybierz jedną lub kilka paczek hooków.',
      loadError: 'Nie udało się wczytać hooków.',
      emptyPre: 'Brak paczek hooków.',
      create: 'Dodaj hooki',
      none: 'Bez hooka',
      // Próbka z wybranej kolekcji — dwa prawdziwe hooki, żeby było wiadomo, co wypadnie.
      sample: 'Z paczki „{name}” - {n} z {total}',
      // Liczba hookow z `item_count`: podsumowanie kroku i naglowek grupy przy 2+ paczkach.
      count_one: '{count} hook',
      count_few: '{count} hooki',
      count_many: '{count} hooków',
      valuesHelp: 'Ta paczka używa zmiennych. Wartości obowiązują raz dla całej serii.',
      artistLabel: 'Nazwa artysty',
      artistHelp: 'Podstawiamy ją dokładnie w miejsce {artist}.',
      artistInvalid: 'Usuń nawiasy klamrowe i niedozwolone znaki.',
      timestampLabel: 'Moment w utworze',
      timestampHelp: 'Wpisz ręcznie jako M:SS, np. 0:12. Nie pobieramy go z fragmentu utworu.',
      timestampInvalid: 'Wpisz moment jako M:SS, np. 0:12. Sekundy muszą mieć wartość od 00 do 59.',
      invalidValues: 'Popraw wartości zmiennych szablonu.',
    },
  },
  // ── Reguła 44 (właściciel, 21.09): ustawienia wyboru wielokrotnego mieszkają
  // przy wierszu, który ich wymaga. Znak „!” i cichy glif nie mają własnej nazwy,
  // więc nazwę dla czytnika niesie ten blok; „Stałe” to słowo właściciela („TAM się
  // uzupełnia te stałe”) i ta sama grupa co w oknie „Zmienne” (reguła 33).
  stepSettings: {
    open: 'Ustawienia kroku',
    attention: 'Ustawienia kroku, wymaga uwagi',
    done: 'Gotowe',
    // Suma jest DANĄ, nie zdaniem, i chodzi w pełnych procentach (reguła 39).
    sum: 'Suma: 100 %',
    constants: 'Stałe',
    // Blokada startu przy pustej stałej (G5): pigułka w linii licznika i mała droga.
    missing: 'brakuje stałych hooka',
    fill: 'Uzupełnij stałe',
  },
  preview: {
    miniTitle: 'Podgląd bez dźwięku',
    miniPlay: 'Odtwórz podgląd', miniPause: 'Zatrzymaj podgląd',
    miniNote: 'Twój utwór i aktualne ustawienia. Zmiany zobaczysz tutaj.',
    title: 'Podgląd',
    waitingTitle: 'Czeka na utwór',
    waitingBody: 'Wybierz utwór w kroku 1, a podgląd zagra.',
    loadingTitle: 'Ładuje podgląd',
    nothingTitle: 'Edit byłby czarnym ekranem',
    unavailableTitle: 'Podgląd nie odpowiedział',
    unavailableBody: 'Render działa mimo to.',
    waiting: 'Wybierz utwór, żeby wczytać podgląd',
    failed: 'Nie udało się wczytać podglądu',
    unavailable: 'Podgląd nie jest dostępny w tej wersji.',
    // D-022: paczki EDIMI pokazują w podglądzie stop-klatki (ten sam JPEG co
    // w pickerze), a nie wideo. Mówimy to wprost, bo różnica jest widoczna —
    // milczenie kazałoby użytkownikowi myśleć, że gotowy edit też będzie stał.
    stockStills: 'Gdy klip nie ma podglądu wideo, pokazujemy jego klatkę. W gotowym edicie klip jest ruchomy.',
    // Losuje NOWY zestaw klipów z tych samych paczek. „Przetasuj", nie „odśwież" —
    // odświeżenie sugerowałoby ten sam wynik jeszcze raz.
    rerollTitle: 'Przetasuj',
    toolbarLabel: 'Narzędzia podglądu',
    socialGuideLabel: 'Strefy zasłonięcia',
    socialGuideShow: 'Pokaż na podglądzie',
  },
  manual: {
    open: 'Edytuj ręcznie',
    title: 'Edytuj klipy i hook',
    // Zakres planu ręcznego jako dana: pigułka przy tytule okna i wiersz w oknie
    // potwierdzenia serii. Pełne zdanie zostaje dla czytnika i w `title`.
    scope: 'edit 1 z {n}',
    scopeFull: 'Ręczne zmiany dotyczą pierwszego podglądanego editu. Pozostałe edity serii losują się normalnie.',
    confirmRow: 'Ręczne zmiany',
    previewTitle: 'Podgląd editu',
    clipsTitle: 'Klipy na osi czasu',
    clipsCount: 'Klipy: {count}',
    selectClip: 'Wybierz klip {n}',
    selectedClip: 'Wybrany klip: {n}',
    rerollClip: 'Przetasuj wybrany klip',
    onlyClip: 'W tej konfiguracji nie ma innego klipu do wylosowania.',
    hookTitle: 'Hook',
    noHook: 'Ten edit nie ma hooka.',
    rerollHook: 'Przetasuj tylko hook',
    resizeHook: 'Zmień szerokość hooka od prawej',
    resizeHookLeft: 'Zmień szerokość hooka od lewej',
    scaleHookLeft: 'Powiększ lub pomniejsz hook od lewego rogu',
    scaleHookRight: 'Powiększ lub pomniejsz hook od prawego rogu',
    centerHook: 'Wyśrodkuj',
    moveHook: 'Przesuń hook',
    onlyHook: 'Wybierz kolekcję z co najmniej dwoma hookami.',
    error: 'Nie udało się przetasować tego elementu. Spróbuj ponownie.',
    syncing: 'Aktualizujemy podgląd hooka przed renderem.',
    syncError: 'Podgląd hooka nie potwierdził nowego tekstu. Spróbuj ponownie przed renderem.',
    retry: 'Ponów podgląd',
    liveNote: 'Ręczne zmiany tworzą dokładnie pierwszy edit z podglądu. Pozostałe edity serii losują się automatycznie.',
    done: 'Gotowe',
  },
  campaign: {
    title: 'Zaplanuj publikację po renderze',
  },
  appearance: {
    bars: 'Paski', noBars: 'Wyłączone', barSize: 'Wysokość pasków', barColor: 'Kolor pasków',
    hook: 'Wygląd hooka', textColor: 'Kolor tekstu', font: 'Czcionka', effect: 'Efekt',
    backgroundColor: 'Kolor tła', none: 'Bez efektu', shadow: 'Cień', box: 'Tło',
    customColor: '{target}: własny kolor', quickColor: '{target}: {color}',
    square: '1:1',
  },
  // Wybór fragmentu utworu (≤30 s — SPEC, edit powstaje z jednego okna).
  trim: {
    cardTitle: 'Fragment na edit',
    rowLabel: 'Fragment editu',
    cardSub: 'Każdy edit powstaje z jednego fragmentu, maksymalnie 30 sekund.',
    edit: 'Zmień fragment',
    loudest: '{len} s · najgłośniejsze okno',
    windowLen: '{len} s',
    title: 'Wybierz fragment',
    // Sufit długości okna jako etykieta przy chipach, liczona z `maxLen` okna.
    maxLen: 'maks. {n} s',
    start: 'Początek',
    end: 'Koniec',
    length: 'Długość',
    keys: {
      handle: 'uchwyt o 0,1 s',
      shift: '+ strzałka o 1 s',
      tab: 'drugi uchwyt',
    },
    jumpTo: 'Skocz do',
    rise: 'Wzrost {n}',
    fromPeaks: 'z realnych szczytów',
    play: 'Odtwórz fragment',
    pause: 'Pauza',
    loading: 'Wczytuję falę…',
    // Fala jest wygodą, nie warunkiem: sam stan pasa, bez ogona o tym, co wolno.
    noWave: 'fala jeszcze się nie policzyła',
    playEnding: 'Odsłuchaj końcówkę',
    pauseEnding: 'Pauza końcówki',
    fullMode: 'Cały fragment',
    endingMode: 'Końcówka w pętli',
    readyToPlay: 'Gotowe do odsłuchu',
    fades: 'Wyciszenie fragmentu',
    fadeIn: 'Łagodne wejście',
    fadeOut: 'Łagodne wyjście',
    fadeHelp: '0-{max} s na każdą stronę',
    fadeSummary: 'wejście {in}s · wyjście {out}s',
    audioLoading: 'Przygotowuję odsłuch…',
    audioError: 'Nie udało się przygotować odsłuchu utworu.',
    retryAudio: 'Spróbuj ponownie',
    playbackError: 'Nie udało się odtworzyć fragmentu. Spróbuj ponownie.',
    save: 'Zapisz fragment',
    cancel: 'Anuluj',
  },
  batch: {
    packs: '{count} paczek',
    packs_one: '{count} paczka',
    packs_few: '{count} paczki',
    packs_many: '{count} paczek',
  },
  // ── D-021: limit słów w linii ──────────────────────────────────────────────
  // Limit jest PER STYL (`app/lyrics/lyric_categories.py`: brat 4;
  // elegant/statement/classic 6; pozostałe 8; bold_pink i karaoke bez limitu),
  // a po przekroczeniu silnik ŁAMIE LINIĘ — `shouldForceBreak` w
  // `lineHelpers.ts` zaczyna nową linię i NIC nie ucina. Dlatego copy nigdy nie
  // mówi „zostaną obcięte" ani „nie zmieszczą się": to byłaby zapowiedź utraty
  // tekstu, której silnik nie robi, a użytkownik skróciłby swoje lyrics bez
  // powodu. Licznik liczy atomy (słowa sklejone `glue_after` idą jako jedno),
  // stąd „około".
  lyricLimits: {
    hint: 'Ten styl mieści około {max} słów w linii.',
    willSplit_one: 'Jedna linia jest dłuższa niż {max} słów - EDIMI podzieli ją na więcej linii.',
    willSplit_few: '{count} linie są dłuższe niż {max} słów - EDIMI podzieli je na więcej linii.',
    willSplit_many: '{count} linii jest dłuższych niż {max} słów - EDIMI podzieli je na więcej linii.',
    noLimit: 'Ten styl nie ma limitu słów w linii.',
  },
  // Ostatni segment klucza = DOKŁADNA wartość silnika
  // (`props_builder.py` VALID_CLIP_FIT_MODES / `BasicComposition/schema.ts:127`).
  clipFit: {
    label: 'Kadrowanie klipów',
    cover: 'Pełny ekran',
    square_cover: 'Cały klip',
    square_contain: 'Z marginesem',
    desc: {
      cover: 'klip wypełnia kadr 9:16',
      square_cover: 'widać całość, pasy po bokach',
      square_contain: 'klip mniejszy, pasy góra i dół',
    },
  },
  // Silnik obsługuje `both` i `top`; brak pasków to letterboxSize: 0.
  // Generator ma kontrolę wysokości i koloru przy podglądzie, potwierdzoną MP4.
  letterbox: {
    label: 'Pasy kinowe',
    both: 'Góra i dół',
    top: 'Tylko góra',
    size: 'Wysokość pasa: {value}%',
  },
  advanced: {
    title: 'Zaawansowane',
  },
  // 429: sufit równoległych renderów. NIC NIE ZOSTAŁO POBRANE — odmowa następuje
  // PRZED spendem, więc zdanie mówi to wprost. Bez tego ekran wraca do tej samej
  // nieprawdy, którą naprawialiśmy w „Zwrotach": użytkownik czyta „nie udało się"
  // i szuka gemów, które nigdy nie wyszły z portfela.
  busy: {
    title: 'Za dużo renderów naraz',
    body: 'Nie zaczęliśmy tego renderu i nie pobraliśmy żadnych gemów. Spróbuj za chwilę.',
    retry: 'Spróbuj ponownie',
  },
  // Błąd WCZYTANIA listy, nie utraty materiału. Pierwsze zdanie mówi, że muzyka
  // jest — bo pusty ekran po wgraniu utworów czyta się jak skasowanie konta.
  loadError: {
    title: 'Nie udało się wczytać Twoich utworów',
    body: 'Twoja muzyka jest na miejscu.',
    retry: 'Spróbuj ponownie',
  },
  cutMode: {
    label: 'Tryb cięcia',
    hint: 'zmienia podgląd od razu',
    // Osiem trybow z `lib/cutModes.ts`. Nazwy sa CALYM tekstem pigulki w
    // przelaczniku, wiec sa krotkie i zaczynaja sie od tego, co je rozroznia -
    // „co”, nie „tnij co”. Identyfikatory sa juz polskie, wiec brzmienie idzie
    // za nimi, a nie za angielskim zapasem z komponentu.
    //
    // „downbeaty” zostaje slowem, ktorego uzywa odbiorca: to produkt dla muzykow,
    // a „tylko pierwsze miary” jest scislejsze i o polowe dluzsze w pigulce, ktora
    // stoi obok siedmiu innych.
    brak: 'bez cięć',
    co_pol_bita: 'co pół bita',
    co_bit: 'co bit',
    co_2_bity: 'co 2 bity',
    co_4_bity: 'co 4 bity',
    co_8_bitow: 'co 8 bitów',
    tylko_downbeaty: 'tylko downbeaty',
    custom: 'własny',
  },
  // Okno „Własne cięcia” (paczka 40b, MAPA 39-R3 „Nowe teksty R3”): same nazwy i dane, zero zdań instrukcji.
  customCuts: {
    open: 'Wystukaj',
    title: 'Własne cięcia',
    unit_one: 'cięcie',
    unit_few: 'cięcia',
    unit_many: 'cięć',
    play: 'Odtwórz',
    stop: 'Zatrzymaj',
    undo: 'Cofnij',
    clear: 'Wyczyść',
    done: 'Gotowe',
    // Napis na narysowanym klawiszu (1440) i na polu dotyku (390).
    key: 'Spacja',
    tap: 'Stuknij',
    // Nazwy dla czytnika ekranu.
    speed: 'Prędkość',
    add: 'Dodaj cięcie',
    remove: 'Usuń cięcie',
    rejected: 'cięcie odrzucone',
    audioError: 'Nie udało się wczytać dźwięku.',
    // Potwierdzenie przy zmianie fragmentu, gdy są wystukane cięcia: skutek jako tytuł.
    changeFragment_one: 'Zmiana fragmentu usunie {count} cięcie',
    changeFragment_few: 'Zmiana fragmentu usunie {count} cięcia',
    changeFragment_many: 'Zmiana fragmentu usunie {count} cięć',
    changeFragmentConfirm: 'Zmień fragment',
    // To samo pytanie przy zmianie UTWORU: inny utwór przestawia fragment (przegląd D, GEN-3).
    changeTrack_one: 'Zmiana utworu usunie {count} cięcie',
    changeTrack_few: 'Zmiana utworu usunie {count} cięcia',
    changeTrack_many: 'Zmiana utworu usunie {count} cięć',
    changeTrackConfirm: 'Zmień utwór',
  },
  presets: {
    templateLabel: 'Szablon',
    newTemplate: 'Nowy szablon',
    loadTitle: 'Wczytaj szablon',
    saveTitle: 'Zapisz szablon',
    saveOpen: 'Nazwij i zapisz szablon',
    label: 'Zapisane szablony',
    save: 'Zapisz',
    load: 'Wczytaj szablon',
    select: 'Wybierz zapisany szablon',
    namePlaceholder: 'Nazwa szablonu',
    loading: 'Wczytuję szablony…',
    empty: 'Nie masz jeszcze zapisanych szablonów.',
    retry: 'Spróbuj ponownie',
    loadError: 'Nie udało się wczytać zapisanych szablonów.',
    active: 'aktywne: {name}',
    delete: 'Usuń szablon „{name}”',
    saved: 'Szablon „{name}” zapisany.',
    saveError: 'Nie udało się zapisać szablonu.',
    deleted: 'Szablon „{name}” usunięty.',
    deleteError: 'Nie udało się usunąć szablonu.',
    saveHint: 'Szablon zapamięta cały zestaw: utwór z fragmentem, paczki, tekst, hooki i ustawienia zaawansowane.',
    loadHint: 'Szablon wczytuje też swój utwór z fragmentem, gdy w kroku 1 nie stoi inny utwór.',
  },
  // Udziały to LICZBY EDITÓW (rozstrzygnięcie 4b), nie proporcje ani procenty:
  // wiersz mówi wprost, ile editów dostanie styl, a suma zgadza się z serią.
  mix: {
    on: 'Ustaw proporcje stylów. Liczbę editów dopasujemy możliwie najbliżej procentów, a kolejność przetasujemy.',
    percentSum: 'Suma: 100%',
    percentLabel: 'Udział procentowy: {name}',
    // Rodziny liczebnika: forma idzie za `total` (edit / edity / editów).
    result_one: '{n} z {total} editu',
    result_few: '{n} z {total} editów',
    result_many: '{n} z {total} editów',
    sum_one: 'suma: {total} edit',
    sum_few: 'suma: {total} edity',
    sum_many: 'suma: {total} editów',
    stepper: 'Udział: {name}',
    add: 'Dodaj styl',
    remove: 'Usuń {name} z miksu',
    tooFew: 'Mniej editów niż pozycji - udziały rozdaje losowanie. Dodaj edity, żeby je ustawić.',
  },
  shares: {
    packs: 'Proporcje paczek klipów', hooks: 'Proporcje paczek hooków',
    mixedHelp: 'Procenty określają liczbę klipów z każdej paczki w całej serii. Podział zaokrąglamy do najbliższej możliwej liczby klipów.',
    singleHelp: 'Procenty określają liczbę editów z każdej paczki. Jeden edit używa tylko jednej paczki.',
    hookHelp: 'Procenty określają liczbę editów z hookiem z każdej paczki. Podział będzie możliwie bliski tym proporcjom.',
  },
  packMode: {
    shortLabel: 'Tryb',
    mixedTooltip: 'Miesza klipy z wybranych paczek w jednym edicie.',
    singleTooltip: 'Każdy edit korzysta z jednej paczki. Klipy różnych paczek nie mieszają się w tym samym edicie.',
    label: 'Jak używać paczek klipów',
    mix: 'Miksuj wszystkie',
    mixHelp: 'Każdy edit bierze klipy ze wszystkich zaznaczonych paczek.',
    single: 'Jedna paczka na edit',
    singleHelp: 'Każdy edit korzysta z jednej paczki, więc wygląda jak z jednej sesji. Liczba przy paczce mówi, ile editów dostanie.',
    mixShort: 'miks wszystkich',
    singleShort: 'jedna paczka na edit',
  },
  cost: {
    amount_one: '1 token',
    amount_few: '{count} tokeny',
    amount_many: '{count} tokenów',
  },
  // Zdanie przy WYŁĄCZONYM przycisku generowania (P03, R-1(ii)). Pokazywane
  // wyłącznie wtedy, gdy podgląd ODPOWIEDZIAŁ `drawsNothing === true` — nigdy przy
  // `undefined`, bo brak odpowiedzi to nie jest pusta konfiguracja i wyłączony
  // przycisk przy wolnym podglądzie blokowałby dobry edit bez powodu.
  // Mówi, CO zrobić (trzy rzeczy, które użytkownik kontroluje), a potem dlaczego —
  // w tej kolejności, bo to jest podpis pod martwym przyciskiem, a nie diagnoza.
  nothingToDraw: 'Dodaj paczkę klipów, tekst albo hook - bez tego edit byłby czarnym ekranem.',
  // Paczka P1 C (reguła 48): SAM CZASOWNIK. Kwotę dokłada `PayLabel` jako daną
  // (moneta + liczba), więc etykieta nie nosi już ani liczby, ani słowa waluty.
  generateVerb: 'Wygeneruj',
  // Akcja BEZ liczby: cennik jeszcze nie przyszedł z serwera, więc nie zgadujemy ceny.
  generatePlain: 'Wygeneruj edit',
  batchQueued: {
    // Toast po serii niesie fakt i liczbę ZE ZNAKIEM (reguła 30, R2 punkt 30); od paczki
    // P1 C liczba jest KWOTĄ (moneta + liczba), więc klucze `cost_*` ze słowem zniknęły.
    title: 'Seria w kolejce',
  },
  design: {
    intro: 'Twój utwór, wybrane kadry i tekst. Ułóż swój edit.',
    musicHint: 'Zacznij od muzyki i wybierz najlepszy fragment.',
    packsHint: 'Nadaj klimat z gotowych paczek lub własnych klipów.',
    textHint: 'Dobierz sposób, w jaki tekst pojawi się w rytmie.',
    hookHint: 'Opcjonalny napis na start. Wybierasz go sam.',
    mixHint: '{n} stylów w wybranych proporcjach',
    cardTitle: 'Seria',
    seriesName: 'Nazwa serii (opcjonalnie)',
    countLabel: 'Ile editów',
    countHint: 'Wpisz liczbę albo wybierz skrót · do {max} w jednej serii',
    allStyles: 'Wszystkie 16 stylów - {hidden} więcej',
    fewerStyles: 'Mniej stylów - pokaż {n}',
    noTextStyle: 'Bez tekstu',
    styleMeta: 'tekst w rytmie utworu',
    noTextMeta: 'sam kadr i hook',
    goToStep: 'Do kroku {n}',
    goToClips: 'Do Klipów',
    // Słowo stanu podglądu — pigułka nad ramką (G4-generator-25): stan wyprowadzony z ramki.
    previewWaiting: 'czeka na utwór',
    previewLoading: 'ładuje',
    previewUnavailable: 'niedostępny',
    previewPlaying: 'na żywo',
    previewNothing: 'nic do narysowania',
    restoreLoadingTitle: 'Odtwarzamy ustawienia serii',
    restoreLoadingBody: 'Czekamy na zapisany formularz. Generator pozostaje zablokowany, dopóki nie sprawdzimy tej serii.',
    restoreErrorTitle: 'Nie udało się odtworzyć tej serii',
    restoreErrorBody: 'Link jest nieaktualny albo seria nie należy do tego konta. Nie uruchomimy renderu z domyślnych ustawień.',
    restoreStartFresh: 'Ustaw nową serię',
    styleLimit: 'Limit w jednej linii: około {max}.',
    styleNoLimit: 'Ten styl zapisuje słowo po słowie. Niczego nie dzielimy.',
    // Trzy fakty bez powtórzeń (G4-generator-05): edity × cena = gemy / saldo przed → po / czas.
    costLine: '{edits} × {gems}',
    balanceLine: 'Stan konta {balance} · zostanie {after}',
    remainingBalance: 'Zostanie {after}',
    renderTimeLabel: 'Czas renderu',
    renderTime: 'około 1-1,5 min na edit',
    stickyLine: '{edits} × {gems} · zostanie {after}',
    reduce_one: 'Zmniejsz do {count} editu',
    reduce_few: 'Zmniejsz do {count} editów',
    reduce_many: 'Zmniejsz do {count} editów',
    insufficient: 'Masz {balance}, potrzeba {cost} - brakuje {missing}.',
    topup: 'Doładuj tokeny',
    ready: 'Wszystko gotowe: utwór, klipy i styl.',
    waitingMusic: 'Najpierw wybierz gotowy utwór.',
    waitingPacks: 'Wybierz klipy.',
    unusablePacks: 'Wybrana paczka nie ma użytecznych klipów. Wybierz paczkę EDIMI albo zatwierdź klipy w Klipach.',
    waitingConfig: 'Czekamy na konfigurację cen - to chwila.',
    restoringSeries: 'Wczytujemy ustawienia serii…',
    // Nie wołane od sesji 19 (decyzja 2: limit równoległych renderów pilnuje backend,
    // `too_many_inflight` → dialog „busy”). Zostaje w słowniku, bo nic go nie zastępuje.
    seriesInProgress: 'Seria w toku - nowa seria po jej zakończeniu.',
    // Sesja 19 C: przycisk w nagłówku cofa generator do stanu początkowego. Zapisany
    // szablon zostaje w szablonach - odpinamy go, nie kasujemy.
    clear: 'Wyczyść',
    clearNone: 'Nic do wyczyszczenia.',
    clearConfirmTitle: 'Wyczyścić ustawienia?',
    clearConfirmBody: 'Generator będzie pusty - utwór, paczki i resztę wybierzesz od nowa. Zapisany szablon „{name}” zostaje w Twoich szablonach - tylko go odpinamy.',
    clearItems: {
      track: 'Utwór i wybrany fragment',
      packs: 'Paczki klipów ({n}) z wagami i trybem',
      style: 'Styl tekstu i wygląd',
      hooks: 'Hooki - hook na start, kolekcja, wagi',
      series: 'Seria: liczba editów (wraca do 1) i nazwa',
      advanced: 'Zaawansowane: tryb cięcia, seed, warianty, dopasowanie klipów, plan ręczny',
      audio: 'Audio: przycięcie i przejścia',
      template: 'Szablon wraca do „Nowy szablon”',
    },
  },
  styleGroups: {
    clean: 'Czyste',
    loud: 'Głośne',
    y2k: 'Y2K',
    soft: 'Miękkie',
    none: 'Bez napisów',
    search: 'Szukaj stylu…',
    sheetTitle: 'Wszystkie style ({total})',
  },
  seriesCard: {
    eyebrow: 'Bieżąca seria',
    untitled: 'Seria bez nazwy',
    renderingTitle: 'Seria "{title}" renderuje się',
    partialTitle: 'Seria "{title}" wymaga uwagi',
    readyTitle: 'Seria "{title}" gotowa',
    failedTitle: 'Seria "{title}" nie wyszła',
    emptyTitle: 'Seria "{title}" jest pusta',
    renderingStatus: '{done} z {total} gotowe',
    partialStatus: '{done} z {total} gotowe',
    readyStatus: '{done} z {total} gotowe',
    failedStatus: '0 z {total} gotowych',
    emptyStatus: 'brak editów',
    editName: 'Edit {n}',
    styleUnknown: 'styl z zapisanych ustawień',
    progressLabel: 'Postęp editu {n}',
    chunks: '{done} z {total} kawałków',
    queued: 'w kolejce',
    rendering: 'renderuje się',
    done: 'gotowy',
    failed: 'nie wyszedł',
    refundConfirmed: 'Zwrot potwierdzony: {gems}',
    refundPending: 'Rozliczenie zwrotu jest w toku',
    retry: 'Ponów edit {n}',
    retryError: 'Nie udało się ponowić tego editu.',
    ledger: 'Pobrano z konta: {charged}. Potwierdzone zwroty: {refunded}.',
    open: 'Zobacz serię',
    newSeries: 'Ustaw kolejną serię',
  },
  invalid: {
    title: 'Nieprawidłowa konfiguracja',
    sub: 'Sprawdź wybór utworu i klipów, a potem spróbuj ponownie.',
    ok: 'Zamknij',
    templateTitle: 'Uzupełnij stałe hooka',
    templateMissing: 'Uzupełnij: {fields}.',
    templateInvalid: 'Popraw wartości pól: {fields}. Nic nie zostało pobrane.',
    nickField: 'nick artysty',
    titleField: 'tytuł',
    fixTemplateValues: 'Przejdź do stałych',
  },

  // ── Paczka 39 (język minimal, MINIMAL-2026-09-18) ────────────────────────────
  // Nowe teksty ekranu przerysowanego na język minimal. Każdy ma uzasadnienie
  // w MAPA sesji 39 („Nowe teksty”); pigułki zastępują zdania powodu (zasada 8),
  // a słowem waluty jest TOKEN (reguła 34).
  origin: {
    series: 'z serii „{name}”',
    music: 'z Muzyki',
  },
  pill: {
    waitingTrack: 'czeka na utwór',
    analyzing: 'analizuję',
    noLyrics: 'bez słów',
    beatsUnknown: 'rytm nie policzony',
    badFile: 'plik uszkodzony',
    // Lekcja z awarii dostawcy transkrypcji: „plik uszkodzony” przy cudzej awarii
    // to kłamstwo, które każe artystcie wgrywać zdrowy plik jeszcze raz.
    analysisFailed: 'analiza nie wyszła',
    noPacks: 'brak paczek klipów',
    pickClips: 'wybierz klipy',
    unusable: 'bez użytecznych klipów',
    freshCut: 'świeżo pocięta',
    black: 'czarny ekran',
    counting: 'liczę',
    noAnswer: 'bez odpowiedzi',
    locked: 'konto czeka na akceptację',
    noWave: 'fala się liczy',
    missing_one: 'brakuje {count} tokena',
    missing_few: 'brakuje {count} tokenów',
    missing_many: 'brakuje {count} tokenów',
  },
  menu: {
    template: 'Szablon',
    load: 'Wczytaj szablon',
    save: 'Zapisz szablon',
  },
  more: {
    open: 'Więcej opcji',
    title: 'Więcej opcji',
  },
  panel: {
    appearance: 'Wygląd pasków i hooka',
    zones: 'Strefy zasłonięcia',
    cut: 'Tryb cięcia',
  },
  card: {
    collapse: 'Zwiń podgląd',
    expand: 'Rozwiń podgląd',
  },
  sheet: {
    tracks: 'Utwory · {total}',
    packs: 'Paczki klipów · {total}',
  },
  pick: {
    fromMusic: 'Wybierz z Muzyki',
    plain: 'Gotowe',
    packs_one: 'Gotowe · {count} paczka',
    packs_few: 'Gotowe · {count} paczki',
    packs_many: 'Gotowe · {count} paczek',
    styles_one: 'Gotowe · {count} styl',
    styles_few: 'Gotowe · {count} style',
    styles_many: 'Gotowe · {count} stylów',
  },
  flow: {
    confirmTitle_one: 'Wygenerować {count} edit?',
    confirmTitle_few: 'Wygenerować {count} edity?',
    confirmTitle_many: 'Wygenerować {count} editów?',
    cost: 'Koszt',
    have: 'Masz',
    after: 'Zostanie',
    missing: 'Brakuje',
    noTokensTitle: 'Za mało tokenów',
    progressTitle: 'Składam Twój edit…',
    doneTitle: 'Edit gotowy',
    seeEdits: 'Zobacz edity',
    failedTitle: 'Błąd renderu',
    status: 'Status',
    statusFailed: 'Błąd',
    refunded: 'Zwrócone tokeny',
    retry_one: 'Spróbuj ponownie · {count} token',
    retry_few: 'Spróbuj ponownie · {count} tokeny',
    retry_many: 'Spróbuj ponownie · {count} tokenów',
  },
}
